module.exports = __webpack_public_path__ + "img/icon-loader.e2fd5101.svg";